import { formatDuration } from 'date-fns';
import { TariffViewModel } from '@common/model/billing/tariff/view';
import { parse as parseISO8601Duration } from 'iso8601-duration';
import { ru } from '@cp/shared/lib';

export const getTariffTermLabel = (tariff: Pick<TariffViewModel, 'period'>): string => {
  if (!tariff.period) {
    console.error('Период действия тарифа не указан');
    return '';
  }
  return formatDuration(parseISO8601Duration(tariff.period), { locale: ru });
};
